// Puantaj Mock Data — personel.js ile uyumlu ID'ler kullanır
// Tarihler: son 7 gün civarı (dinamik hesaplanır)

const today = new Date();
const formatDate = (d) => d.toISOString().split('T')[0];
const daysAgo = (n) => { const d = new Date(today); d.setDate(d.getDate() - n); return formatDate(d); };

export const puantajKayitlari = [
    // Bugün
    {
        id: 'p-001', tarih: daysAgo(0), personelId: 'per-1', personelAdi: 'Hasan Yıldırım',
        gorev: 'Usta', baslangic: '08:00', bitis: '17:30', molaSaat: 1, calismaSaat: 8.5,
        fazlaMesai: 0.5, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-002', tarih: daysAgo(0), personelId: 'per-2', personelAdi: 'Murat Demir',
        gorev: 'İnşaat İşçisi', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-003', tarih: daysAgo(0), personelId: 'per-4', personelAdi: 'Ali Kara',
        gorev: 'Kalıpçı', baslangic: '07:30', bitis: '17:00', molaSaat: 1, calismaSaat: 8.5,
        fazlaMesai: 0.5, durum: 'calisti', not: 'Kalıp söküm işleri', insaatId: 'c-001'
    },
    {
        id: 'p-004', tarih: daysAgo(0), personelId: 'per-6', personelAdi: 'Osman Ak',
        gorev: 'Boyacı', baslangic: '', bitis: '', molaSaat: 0, calismaSaat: 0,
        fazlaMesai: 0, durum: 'izinli', not: 'Yıllık izin', insaatId: 'c-001'
    },
    {
        id: 'p-005', tarih: daysAgo(0), personelId: 'per-8', personelAdi: 'Emre Yılmaz',
        gorev: 'Elektrikçi', baslangic: '08:00', bitis: '18:00', molaSaat: 1, calismaSaat: 9,
        fazlaMesai: 1, durum: 'calisti', not: 'Tesisat çekimi', insaatId: 'c-001'
    },
    {
        id: 'p-006', tarih: daysAgo(0), personelId: 'per-9', personelAdi: 'Burak Aslan',
        gorev: 'Tesisatçı', baslangic: '08:00', bitis: '12:00', molaSaat: 0, calismaSaat: 4,
        fazlaMesai: 0, durum: 'yarim_gun', not: 'Öğleden sonra hastaneye gitti', insaatId: 'c-001'
    },
    // Dün
    {
        id: 'p-007', tarih: daysAgo(1), personelId: 'per-1', personelAdi: 'Hasan Yıldırım',
        gorev: 'Usta', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-008', tarih: daysAgo(1), personelId: 'per-2', personelAdi: 'Murat Demir',
        gorev: 'İnşaat İşçisi', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-009', tarih: daysAgo(1), personelId: 'per-3', personelAdi: 'Kemal Öz',
        gorev: 'İnşaat İşçisi', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-010', tarih: daysAgo(1), personelId: 'per-4', personelAdi: 'Ali Kara',
        gorev: 'Kalıpçı', baslangic: '07:30', bitis: '18:00', molaSaat: 1, calismaSaat: 9.5,
        fazlaMesai: 1.5, durum: 'calisti', not: 'Fazla mesai', insaatId: 'c-001'
    },
    {
        id: 'p-011', tarih: daysAgo(1), personelId: 'per-5', personelAdi: 'Veli Güneş',
        gorev: 'Kalıpçı', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-012', tarih: daysAgo(1), personelId: 'per-6', personelAdi: 'Osman Ak',
        gorev: 'Boyacı', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: 'Dış cephe boya', insaatId: 'c-001'
    },
    {
        id: 'p-013', tarih: daysAgo(1), personelId: 'per-7', personelAdi: 'Salih Deniz',
        gorev: 'Boyacı', baslangic: '', bitis: '', molaSaat: 0, calismaSaat: 0,
        fazlaMesai: 0, durum: 'raporlu', not: 'Sağlık raporu', insaatId: 'c-001'
    },
    {
        id: 'p-014', tarih: daysAgo(1), personelId: 'per-8', personelAdi: 'Emre Yılmaz',
        gorev: 'Elektrikçi', baslangic: '08:00', bitis: '18:00', molaSaat: 1, calismaSaat: 9,
        fazlaMesai: 1, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-015', tarih: daysAgo(1), personelId: 'per-9', personelAdi: 'Burak Aslan',
        gorev: 'Tesisatçı', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    // 2 gün önce
    {
        id: 'p-016', tarih: daysAgo(2), personelId: 'per-1', personelAdi: 'Hasan Yıldırım',
        gorev: 'Usta', baslangic: '07:30', bitis: '18:00', molaSaat: 1, calismaSaat: 9.5,
        fazlaMesai: 1.5, durum: 'calisti', not: 'Beton dökümü koordinasyonu', insaatId: 'c-001'
    },
    {
        id: 'p-017', tarih: daysAgo(2), personelId: 'per-2', personelAdi: 'Murat Demir',
        gorev: 'İnşaat İşçisi', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-018', tarih: daysAgo(2), personelId: 'per-3', personelAdi: 'Kemal Öz',
        gorev: 'İnşaat İşçisi', baslangic: '', bitis: '', molaSaat: 0, calismaSaat: 0,
        fazlaMesai: 0, durum: 'gelmedi', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-019', tarih: daysAgo(2), personelId: 'per-4', personelAdi: 'Ali Kara',
        gorev: 'Kalıpçı', baslangic: '08:00', bitis: '17:30', molaSaat: 1, calismaSaat: 8.5,
        fazlaMesai: 0.5, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-020', tarih: daysAgo(2), personelId: 'per-8', personelAdi: 'Emre Yılmaz',
        gorev: 'Elektrikçi', baslangic: '08:00', bitis: '16:00', molaSaat: 1, calismaSaat: 7,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    // 3 gün önce
    {
        id: 'p-021', tarih: daysAgo(3), personelId: 'per-1', personelAdi: 'Hasan Yıldırım',
        gorev: 'Usta', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-022', tarih: daysAgo(3), personelId: 'per-5', personelAdi: 'Veli Güneş',
        gorev: 'Kalıpçı', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: '', insaatId: 'c-001'
    },
    {
        id: 'p-023', tarih: daysAgo(3), personelId: 'per-7', personelAdi: 'Salih Deniz',
        gorev: 'Boyacı', baslangic: '08:00', bitis: '17:00', molaSaat: 1, calismaSaat: 8,
        fazlaMesai: 0, durum: 'calisti', not: 'İç mekan boya', insaatId: 'c-001'
    },
    {
        id: 'p-024', tarih: daysAgo(3), personelId: 'per-9', personelAdi: 'Burak Aslan',
        gorev: 'Tesisatçı', baslangic: '08:00', bitis: '18:30', molaSaat: 1, calismaSaat: 9.5,
        fazlaMesai: 1.5, durum: 'calisti', not: 'Su tesisatı acil tamir', insaatId: 'c-001'
    },
];

// Durum seçenekleri
export const calismaDurumlari = [
    { key: 'calisti', label: 'Çalıştı', color: 'success' },
    { key: 'izinli', label: 'İzinli', color: 'info' },
    { key: 'raporlu', label: 'Raporlu', color: 'warning' },
    { key: 'yarim_gun', label: 'Yarım Gün', color: 'secondary' },
    { key: 'gelmedi', label: 'Gelmedi', color: 'error' }
];

// İstatistikler
export const getPuantajStats = (insaatId, tarih) => {
    let filtered = insaatId
        ? puantajKayitlari.filter(k => k.insaatId === insaatId)
        : puantajKayitlari;

    if (tarih) {
        filtered = filtered.filter(k => k.tarih === tarih);
    }

    const toplamPersonel = filtered.length;
    const calisanSayisi = filtered.filter(k => k.durum === 'calisti' || k.durum === 'yarim_gun').length;
    const toplamSaat = filtered.reduce((acc, k) => acc + k.calismaSaat, 0);
    const fazlaMesaiSaat = filtered.reduce((acc, k) => acc + k.fazlaMesai, 0);
    const izinliSayisi = filtered.filter(k => k.durum === 'izinli' || k.durum === 'raporlu').length;

    return { toplamPersonel, calisanSayisi, toplamSaat, fazlaMesaiSaat, izinliSayisi };
};

// Helper: tarihe göre filtrele
export const getPuantajByTarih = (tarih, insaatId) => {
    let data = insaatId
        ? puantajKayitlari.filter(k => k.insaatId === insaatId)
        : puantajKayitlari;

    if (tarih) {
        data = data.filter(k => k.tarih === tarih);
    }
    return data;
};

// Helper: personel bazlı puantaj geçmişi
export const getPuantajByPersonel = (personelId) => {
    return puantajKayitlari
        .filter(k => k.personelId === personelId)
        .sort((a, b) => b.tarih.localeCompare(a.tarih));
};

// Helper: benzersiz tarihleri al
export const getUniqueTarihler = (insaatId) => {
    const filtered = insaatId
        ? puantajKayitlari.filter(k => k.insaatId === insaatId)
        : puantajKayitlari;

    return [...new Set(filtered.map(k => k.tarih))].sort((a, b) => b.localeCompare(a));
};
